module.exports = __webpack_public_path__ + "static/media/Template_5.7f06e2c8.png";